import * as React from "react";
import "./CaregiverPhoneEntryScreen.css";
import { GenericMaskedInput } from "./inputs/GenericMaskedInput";
import { HRQuestionId } from "../messages";
import * as phone_number from "../phone_number";
import { isPhoneNumberE164 } from "../phone_number";
import { Loading, isLoading } from "../Loading";
import { Intent, Spinner } from "@blueprintjs/core";
import { HRQuestionTemplateId } from "../messages/ObjectIds";

interface CaregiverPhoneEntryScreenProps {
    showInternetError: string | null | Loading;
    onPhoneNumberClick: (phoneNumber: string) => void;
}

interface CaregiverPhoneEntryScreenState {
    phoneNumber: string | null;
    showPhoneNumberError: boolean;
}

export class CaregiverPhoneEntryScreen extends React.Component<CaregiverPhoneEntryScreenProps, CaregiverPhoneEntryScreenState> {
    constructor(props: CaregiverPhoneEntryScreenProps) {
        super(props);
        this.state = {
            phoneNumber: "",
            showPhoneNumberError: false,
        };
    }

    handlePhoneNumberClick = () => {
        if (this.state.phoneNumber === null) {
            this.setState({ showPhoneNumberError: true });
        } else {
            const phoneE164 = phone_number.parsePhoneToE164("US", this.state.phoneNumber);
            if (phoneE164 !== null && isPhoneNumberE164(phoneE164)) {
                this.setState({ showPhoneNumberError: false });
                this.props.onPhoneNumberClick(phoneE164);
            } else {
                this.setState({ showPhoneNumberError: true });
            }
        }
    }

    handleChange = (newVal: string | null) => {
        this.setState({ phoneNumber: newVal });
    }

    render() {
        return (
            <div className={"CaregiverPhoneEntryScreen__root"}>
                <div className={"CaregiverPhoneEntryScreen__photoContainer"}>
                    <div
                        className={"CaregiverPhoneEntryScreen__photo"}
                    />
                </div>
                <h3 className={"text-secondary mb-120"}>Welcome!</h3>
                <h4 className={"text-secondary mb-0"}>Please type your cell phone number, You will get a text message with a verification code</h4>
                <div className={"CaregiverPhoneEntryScreen__label"}>
                    <GenericMaskedInput
                        hrMaskedQuestion={{
                            question: {
                                type: "PhoneNumber",
                                answer: this.state.phoneNumber,
                                id: HRQuestionId.wrap(1),
                                parentId: null,
                                parentAnswer: null,
                                isHidden: false,
                                textId: HRQuestionTemplateId.wrap("1"),
                                isMandatory: true,
                                questionText: "Phone number"
                            },
                            status: null
                        }}
                        isHidden={false}
                        onChange={(newVal) => this.handleChange(newVal)}
                        onBlur={() => {
                            //
                        }}
                    />
                </div>

                {this.state.showPhoneNumberError ?
                    (
                        <div className={"help-block text-danger"}>
                            Wrong phone number format
                        </div>
                    )
                    :
                    null
                }

                {isLoading(this.props.showInternetError) ?
                    <Spinner intent={Intent.PRIMARY}/>
                    :
                    <span>
                        <button
                            className="CaregiverPhoneEntryScreen__submit btn btn-dark btn-xl"
                            onClick={this.handlePhoneNumberClick}
                        >
                            Next!
                        </button>
                        <div className={"help-block text-danger"}>
                            {this.props.showInternetError}
                        </div>
                    </span>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CaregiverPhoneEntryScreen.tsx